<template>
    <div>
        <!-- @TODO: Add this to a reusable component -->
        <div class="text-center">
            <div class="logo-device text-center mb-6">
                <img :src="global.app.url + 'images/logo-device.svg'" alt="Options Desk O logo" title="Options Desk" />
            </div>

            <h1 class="text-xl uppercase font-semibold mb-5">Password reset</h1>
        </div>
        <!-- @ENDTODO -->

        <ValidationObserver v-slot="{ handleSubmit }" ref="passwordResetObserver">
            <form @submit.prevent="handleSubmit(doPasswordReset)">
                <InputComponent v-model="$route.query.email" disabled type="email" label="Email Address" placeholder="Email Address" :show-success-status="false" />

                <div class="mt-8">
                    <InputComponent v-model="passwordResetForm.password" vid="new-password" name="new_password" type="password" rules="required|min:8" label="New Password" placeholder="New Password" subtext="Minimum 8 characters with at least one number and one special character" />
                </div>

                 <div class="mt-8">
                    <InputComponent v-model="passwordResetForm.confirm_password" name="confirm_new_password" type="password" rules="required|confirmed:new-password" label="Confirm New Password" placeholder="Confirm New Password" />
                </div>

                <div class="mt-8">
                    <AlertComponent :message="global.flashMessage.message" :errors="global.flashMessage.errorList" :color="global.flashMessage.color" />
                </div>

                <div class="mt-8">
                    <ButtonComponent type="submit" color="primary" label="Change Password" :isLoading="passwordResetForm.isChangingPassword" />
                </div>

                <div class="mt-3">
                    <router-link :to="{ name: 'login' }" class="text-white"><span class="icon-arrow-left mr-3 align-middle"></span>Back to login page</router-link>
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from "vee-validate";
import InputComponent from "@components/inputs/InputComponent";
import ButtonComponent from "@components/buttons/ButtonComponent";
import AlertComponent from "@components/misc/AlertComponent";

export default {
    name: "LoginPage",
    components: {
        ValidationObserver,
        InputComponent,
        ButtonComponent,
        AlertComponent
    },
    computed: {
        ...mapGetters(["global"])
    },
    data: function () {
        return {
            isLoading: false,
            passwordResetForm:{
                email: this.$route.query.email,
                password: "",
                confirm_password: "",
                isChangingPassword: false
            }
        };
    },
    methods: {
        ...mapActions(['resetPassword', 'setGlobalFlashResponse', 'resetGlobalFlashResponse']),
        doPasswordReset() {
			this.passwordResetForm.isChangingPassword = true;

			let userCredentials = {
				"email": this.passwordResetForm.email,
				"password": this.passwordResetForm.password,
				"token": this.$route.query.token
			}

			this.resetPassword(userCredentials).then((response) => {
					this.passwordResetForm.isChangingPassword = false;
                    this.passwordResetForm.password = "";
                    this.passwordResetForm.confirm_password = "";
					this.$refs.passwordResetObserver.reset();

					this.setGlobalFlashResponse({
						color: "green",
						message: "Your password has been reset successfully! Redirecting you to the login page..."
					});

					setTimeout(() => {
                        this.resetGlobalFlashResponse();
						this.$router.push({ name: 'login' }); // Redirect to the login page after 5 seconds
					}, 5000);
				},
				(error) => {
					this.passwordResetForm.isChangingPassword = false;
					this.setGlobalFlashResponse({
						message: "There was a problem resetting your password. Please try again."
					});
				});
		}
    },
};
</script>
